var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4411_92012)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.17891 0.928711C9.0463 0.928711 8.91912 0.981389 8.82535 1.07516L1.07418 8.82633C0.878919 9.02159 0.878919 9.33817 1.07418 9.53344L6.88756 15.3468C6.98133 15.4406 7.1085 15.4933 7.24111 15.4933C7.37372 15.4933 7.5009 15.4406 7.59467 15.3468L15.3458 7.59564C15.4396 7.50187 15.4923 7.3747 15.4923 7.24209L15.4923 1.42871C15.4923 1.15257 15.2684 0.928711 14.9923 0.928711L9.17891 0.928711ZM2.13484 9.17988L9.38601 1.92871L14.4923 1.92871L14.4923 7.03498L7.24111 14.2862L2.13484 9.17988ZM11.616 4.33544C11.616 4.07647 11.8259 3.86654 12.0849 3.86654C12.3439 3.86654 12.5538 4.07647 12.5538 4.33544C12.5538 4.5944 12.3439 4.80433 12.0849 4.80433C11.8259 4.80433 11.616 4.5944 11.616 4.33544ZM12.0849 2.86654C11.2737 2.86654 10.616 3.52419 10.616 4.33544C10.616 5.14669 11.2737 5.80433 12.0849 5.80433C12.8962 5.80433 13.5538 5.14669 13.5538 4.33544C13.5538 3.52419 12.8962 2.86654 12.0849 2.86654Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4411_92012"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/Tag.14266e69f265452ca09f94fa2f4f3f2d.svg";
export { ForwardRef as ReactComponent };